import { Navigate, Outlet } from 'react-router-dom';
import { useSelector } from 'react-redux';

/**
 * Lets a signed-in session through. Which pages a profile gets is decided in
 * `AppRouter`, which mounts one route tree per role, so there is no role left
 * to check here.
 */
export const ProtectedRoute = () => {
  const { isAuthenticated } = useSelector((state) => state.auth);

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  return <Outlet />;
};
